document.addEventListener('DOMContentLoaded', function() {
  const hamburger = document.querySelector('.hamburger-icon');
  const menu = document.querySelector('.science-menu');
  const overlay = document.querySelector('.mobile-menu-overlay');
  const closeBtn = document.querySelector('.menu-close');
  const mainContent = document.querySelector('.content-for-layout');
  const htmloverflow = document.querySelector('html');

  hamburger.addEventListener('click', function() {
    menu.classList.add('active');
    mainContent.classList.add('active-z');
    htmloverflow.classList.add('overflow-stop');
  });

  closeBtn.addEventListener('click', function() {
    menu.classList.remove('active');
    mainContent.classList.remove('active-z');
    htmloverflow.classList.remove('overflow-stop');
  });

});